import { playerDataHttpClient } from "@sazka/player/http-clients/player-data-http-client";
import { LoyaltyPlayerStatus } from "./models/loyalty-api-models";
import { BonusomatPlayerStatus } from "./models/bonusomat-player-status";
import { FsPlayerDataStatus } from "./models/fs-player-status";
import { GwPlayerStatus } from "@/loyalty/api/models/gw-player-status";

export async function fetchLoyaltyPlayerStatus(): Promise<LoyaltyPlayerStatus> {
    return (await playerDataHttpClient.get<LoyaltyPlayerStatus>("player")).data;
}

export async function fetchBonusomatPlayerStatus(playerId: string) {
    const response = await playerDataHttpClient.get<BonusomatPlayerStatus>(`players/${playerId}/bonusomat`);

    return response.data;
}
export async function fethGwPlayerStatus(playerId: string): Promise<GwPlayerStatus> {
    const response = await playerDataHttpClient.get<GwPlayerStatus>(`players/${playerId}/golden-wheel`);

    return response.data;
}

export async function fetchFsPlayerStatus() {
    const response = await playerDataHttpClient.get<FsPlayerDataStatus>(`player/furry-spin`);

    return response.data;
}
